const E = (e) => {
  const n = typeof e;
  return n !== "function" && n !== "object" || e === null;
}, M = (e) => {
  const n = e.flags === "" ? void 0 : e.flags;
  return new RegExp(e.source, n);
}, f = (e, n = /* @__PURE__ */ new WeakMap()) => {
  if (e === null || E(e))
    return e;
  if (n.has(e))
    return n.get(e);
  if (e instanceof RegExp)
    return M(e);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof Function)
    return e;
  if (e instanceof Map) {
    const o = /* @__PURE__ */ new Map();
    return n.set(e, o), e.forEach((r, s) => {
      o.set(s, f(r, n));
    }), o;
  }
  if (e instanceof Set) {
    const o = /* @__PURE__ */ new Set();
    n.set(e, o);
    for (const r of e)
      o.add(f(r, n));
    return o;
  }
  if (Array.isArray(e)) {
    const o = [];
    return n.set(e, o), e.forEach((r) => {
      o.push(f(r, n));
    }), o;
  }
  const t = {};
  n.set(e, t);
  for (const o in e)
    Object.prototype.hasOwnProperty.call(e, o) && (t[o] = f(e[o], n));
  return t;
}, R = (e, n = 200) => {
  let t = 0;
  return (...o) => new Promise((r) => {
    t && (clearTimeout(t), r("cancel")), t = window.setTimeout(() => {
      e.apply(void 0, o), t = 0, r("done");
    }, n);
  });
}, C = (e, n = {
  _blank: !0,
  nofollow: !0
}) => {
  const t = document.createElement("a");
  t.href = e, n._blank && (t.target = "_blank"), n.nofollow && (t.rel = "noopener noreferrer"), t.click();
}, O = (e, n = "") => {
  const t = document.createElement("a");
  t.setAttribute("href", e), t.setAttribute("download", n), t.click();
}, L = () => {
  let e = -1;
  return (t, o, r, s = 100) => {
    const c = () => {
      r && (typeof s == "number" ? setTimeout(r, s) : r());
    };
    e !== -1 && (cancelAnimationFrame(e), c());
    let i = t.scrollTop;
    const l = () => {
      e = -1;
      const u = o - i;
      i = i + u / 5, Math.abs(u) < 1 ? (t.scrollTo(0, o), c()) : (t.scrollTo(0, i), e = requestAnimationFrame(l));
    };
    e = requestAnimationFrame(l);
  };
}, k = L(), F = (e, n = 200) => {
  let t = 0, o = null;
  const r = (s) => {
    t === 0 && (t = s), s - t >= n ? (e.apply(void 0, o), o = null, t = 0) : window.requestAnimationFrame(r);
  };
  return (...s) => {
    o === null && window.requestAnimationFrame(r), o = s;
  };
}, H = (e, n = !0) => {
  if (!e)
    return {};
  const t = {};
  return e.replace(/^\?/, "").split("&").forEach((o) => {
    const [r, s] = o.split("=");
    if (r) {
      const c = n ? decodeURIComponent(r) : r, i = n ? decodeURIComponent(s) : s;
      t[c] !== void 0 ? (Array.isArray(t[c]) || (t[c] = [t[c]]), t[c].push(i)) : t[c] = i;
    }
  }), t;
}, U = (e, n = !0) => e ? Object.keys(e).map((t) => {
  const o = n ? encodeURIComponent(t) : t;
  if (Array.isArray(e[t]))
    return e[t].map((r) => {
      const s = n ? encodeURIComponent(r) : r;
      return `${o}=${s}`;
    }).join("&");
  {
    const r = n ? encodeURIComponent(e[t]) : e[t];
    return `${o}=${r}`;
  }
}).join("&") : "", _ = (e, n, t = "asc") => e.sort((o, r) => {
  const s = n(o), c = n(r);
  return s === void 0 && c !== void 0 || s === null && c !== void 0 ? t === "asc" ? -1 : 1 : s == null && c === void 0 || c == null ? t === "asc" ? 1 : -1 : g(s) && g(c) ? t == "asc" ? s - c : c - s : t == "asc" ? String(s).localeCompare(String(c), void 0, {
    numeric: !0
  }) : String(c).localeCompare(String(s), void 0, {
    numeric: !0
  });
}), $ = (e) => {
  const n = (t) => {
    const { scrollHeight: o, scrollWidth: r, offsetHeight: s, offsetWidth: c, scrollLeft: i, scrollTop: l } = e, u = t.x, S = t.y, p = (w) => {
      const a = l + S - w.y, m = i + u - w.x, A = o - s, T = r - c, d = {};
      m >= 0 && m <= T && (d.left = m), a >= 0 && a <= A && (d.top = a), e.scroll(d);
    };
    document.addEventListener("mousemove", p);
    const v = () => {
      document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", v);
    };
    document.addEventListener("mouseup", v);
  };
  return e.addEventListener("mousedown", n), () => {
    e.removeEventListener("mousedown", n);
  };
}, h = () => `${Date.now().toString(36)}${Math.random().toString(36).substring(2)}`, g = (e) => !isNaN(Number(e)), y = (e) => e !== null && typeof e == "object" && !Array.isArray(e), x = (e, n) => {
  for (const t in n)
    y(n[t]) && y(e[t]) ? e[t] = x(
      e[t],
      n[t]
    ) : e[t] = n[t];
  return e;
}, I = (e, n = document.body) => {
  let t = e.offsetParent, o = e.offsetTop, r = e.offsetLeft;
  for (; t !== null && t !== n; )
    o += t.offsetTop, r += t.offsetLeft, t = t.offsetParent;
  return { offsetTop: o, offsetLeft: r };
};
export {
  L as createSmoothScroll,
  R as debounce,
  f as deepClone,
  x as deepMerge,
  O as download,
  $ as draggingScroll,
  I as getRootOffset,
  g as isNumber,
  E as isPrimitive,
  C as linkTo,
  U as objToSearch,
  _ as objectSort,
  H as searchToObj,
  k as smoothScroll,
  F as throttle,
  h as uuid
};
